const alt = require("AltInit");

const { TournamentRound} = require("parse/_Domain");

const parseDao = require("actdao/ParseBaseDao");
const tournamentResultDao = require("actdao/TournamentResultDao");
const notificationActions = require("components/notification/NotificationActions");
const tournamentResultDicActions = require("actions/TournamentResultDicActions");

class TournamentResultActions {

    showResultDetails(tournament) {
        this.loadTournamentRounds(tournament);
        return {};
    };

    loadTournamentRoundResult(tournamentRound, callback) {
        tournamentResultDao.loadTournamentRoundResult(tournamentRound)
            .then(tUserRoundResults => {
                callback(tUserRoundResults)
            })
            .catch(error => {
                error.trace = "TREA.loadTURoundRes";
                notificationActions.parseError(error);
            });
        return {};
    }

    removeTargetsFromResult(targetNrArr, selRound, tUserRoundResult, callback) {
        const hit_zone_matrix = [ 100000, 10000, 1000, 100, 10, 1, 1, 1, 1, 1, 1 ]
        // find event for the tournamentUser
        tournamentResultDao.loadTournamentEventPlayer(selRound, tUserRoundResult.getTournamentUserID())
            .then(resultPlayers => {
                if (resultPlayers.length > 0) {
                    console.log("Found " + tUserRoundResult.getTournamentUserID().getFullName() + " Event: " + resultPlayers[0].getPlayerName());
                    // recalc Result but remove targetNrs
                    let sumPoints = 0;
                    // TODO killCounts
                    let killValue = 0;
                    let killCounts = {};
                    const evRes = resultPlayers[0].getEventResults();
                    evRes.map(evResult => {
                        const evrTargetNr = evResult.getTargetIndex();
                        if (targetNrArr.indexOf(evrTargetNr) === -1) {
                            sumPoints += evResult.getPoints();
                            if (evResult.getKillNr() > 0 && evResult.getKillNr() < hit_zone_matrix.length) {
                                killValue += hit_zone_matrix[evResult.getKillNr() - 1]
                            }

                        }
                    });
                    tUserRoundResult.setCorrectionPoints(sumPoints, killValue);
                    tUserRoundResult.save(null).then(tUpdTUserRoundResult => {
                        callback(tUpdTUserRoundResult)
                    });
                    console.log("Points " +   resultPlayers[0].getSumPoints() + " -> New sum Points " + sumPoints)
                } else {
                    console.log("NOT Found " + tUserRoundResult.getTournamentUserID().getFullName() )
                }
        });
        return {}
    }

    switchWithCorrPoints(tRoundUserResults, callback) {
        tRoundUserResults.map(tRoundUserResult => {
            let corrPoints = tRoundUserResult.getCorrectionPoints();
            let corrKillValues = tRoundUserResult.getCorrectionKillValue();
            if (corrPoints != null) {
                let sumPoints = tRoundUserResult.getRoundPoints();
                let killValue = tRoundUserResult.getKillValue();
                tRoundUserResult.setRoundPoints(corrPoints);
                tRoundUserResult.setKillValue(corrKillValues);
                tRoundUserResult.setCorrectionPoints(sumPoints, killValue);
            }
        });
        parseDao.saveAll(tRoundUserResults)
            .then(result => {
                callback()
            })
            .catch(error => {
                error.trace = "TREA.switchWithCorrPoints";
                notificationActions.parseError(error);
            });
        return {}
    }

    loadTournamentRounds(tournament) {
        // init displayState - G will be replaced to correct group if necessary
        let displayState = tournament.isTypePairRegistration() ? "G" : "S";
        this.updateDisplayState(displayState, true);
        // load rounds
        tournamentResultDao.loadTournamentRounds(tournament)
            .then(tRounds => {
                const params = {needFinalElimination:false, needFinalAdd: false, optionString: null, tConfigCombinedAge: null};
                const tournamentRoundMap = {
                    qualify:[], finale:[], group:[], extra:[]
                }
                tRounds.map(tRound => {
                    if (tRound.isTypeOf(TournamentRound.prototype.typeGroups.group_simple)) {
                        tournamentRoundMap.qualify.push(tRound);
                    } else if (tRound.isTypeOf(TournamentRound.prototype.typeGroups.group_finale)) {
                        if (tRound.isFinalElimination() && !tRound.isPresent()) {
                            // start showing elimination as soon  as a final round is running
                            params.needFinalElimination = true;
                        } else if (tRound.isFinalAdd()) {
                            params.needFinalAdd = true;
                        }
                        tournamentRoundMap.finale.push(tRound);
                    } else if (tRound.isTypeOf(TournamentRound.prototype.typeGroups.group_groups)){
                        tournamentRoundMap.group.push(tRound);
                    } else if (tRound.isTypeOf(TournamentRound.prototype.typeGroups.group_extra)) {
                        tournamentRoundMap.extra.push(tRound);
                    }
                });
                // check for single group round
                if ((tournamentRoundMap.qualify.length === 0 || displayState === "G")
                    && tournamentRoundMap.group.length > 0) {
                    // replace with correct round type
                    displayState = tournamentRoundMap.group[0].getType();
                    this.updateDisplayState(displayState, true);
                }
                this.updateTournamentRoundMap(tournamentRoundMap);
                this.loadTournamentResult(tournament, displayState, params);
            })
            .catch(error => {
                error.trace = "TREA.loadTRounds";
                notificationActions.parseError(error);
            });
        return {};
    };

    loadTournamentResult(tournament, displayState, params) {
        this.updateParams(params);
        if (TournamentRound.prototype.typeGroups.group_groups.includes(displayState)) {
            tournamentResultDicActions.loadTournamentUserTeamResult(tournament, displayState)
                .then(tUserResult => {
                    this.updateTournamentUserResult(tUserResult);
                });
        } else {
            tournamentResultDicActions.loadTournamentUserResult(tournament, null, null, params)
                .then(tUserResult => {
                    this.updateTournamentUserResult(tUserResult);
                })
        }
        return {};
    }

    updateTournamentUserResult(tournamentUserDic) {
        return tournamentUserDic;
    };

    updateTournamentRoundMap(tournamentRoundMap) {
        return tournamentRoundMap;
    };

    resetTournamentResults() {
        return {};
    };

    updateParams(params) {
        return params
    }

    updateDisplayState(displayState, loading) {
        return {displayState: displayState, loading: loading};
    }
}

module.exports = alt.createActions(TournamentResultActions);
